import React from "react";
import { LuSchool } from "react-icons/lu";
import { BsPatchCheck } from "react-icons/bs";
import { FaClinicMedical } from "react-icons/fa";
import { CiStethoscope, CiTrophy } from "react-icons/ci";
import { RiHotelLine, RiSchoolLine } from "react-icons/ri";
import { FaCalendarAlt } from "react-icons/fa";

const SectionCard = ({ title, icon, headerClass, items, colClass }) => (
  <div className={`col-12 col-lg-4 mb-2`}>
    <div className="custom-card">
      <div className={`custom-card-header ${headerClass}`}>
        {icon && <span style={{ marginRight: "8px" }}>{icon}</span>}
        {title}
      </div>
      <div className="custom-card-body">
        <div className="item-list">
          {items.map((item, idx) => (
            <div key={idx} className="custom-item">
              <span className="dot-mark"></span>
              <div className="item-content">
                <h6>{item.title}</h6>
                {item.subtitle && (
                  <small className="subtitle">{item.subtitle}</small>
                )}
              </div>
              {item.year && (
                <small className="badge">
                  <FaCalendarAlt
                    style={{ marginRight: "4px", verticalAlign: "middle" }}
                  />
                  {item.year}
                </small>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

const EducationProfileUpdated = ({ tabData }) => {
  const getIcon = (title) => {
    const iconMap = {
      Education: <LuSchool />,
      Undergraduate: <LuSchool />,
      Graduate: <LuSchool />,
      "Chiropractic School": <LuSchool />,
      "Medical School": <FaClinicMedical />,
      Residency: <RiHotelLine />,
      Fellowship: <RiSchoolLine />,
      "Certificate and Licensure": <BsPatchCheck />,
      Societies: <BsPatchCheck />,
      Internship: <CiStethoscope />,
      Other: <CiTrophy />,
    };
    return iconMap[title] || null;
  };

  const getHeaderClass = (title) => {
    const classMap = {
      Education: "education-header",
      Undergraduate: "undergraduate-header",
      Graduate: "graduate-header",
      "Chiropractic School": "chiropractic-header",
      "Medical School": "medical-header",
      Residency: "residency-header",
      Fellowship: "fellowship-header",
      "Certificate and Licensure": "certificate-header",
      Societies: "societies-header",
      Internship: "internship-header",
      Other: "other-header",
    };
    return classMap[title] || "other-header";
  };

  const transformData = (data) => {
    return data.map((section) => {
      const updatedTitle =
        section.title === "Orthopaedic Residency" ? "Residency" : section.title;

      const transformedItems = section.description.map((descArray) => {
        if (descArray.length === 3) {
          return {
            title: descArray[0],
            subtitle: descArray[1],
            year: descArray[2],
          };
        } else if (descArray.length === 1) {
          return {
            title: descArray[0],
          };
        }
        return { title: descArray[0] || "Unknown" };
      });

      return {
        title: updatedTitle,
        items: transformedItems,
      };
    });
  };

  const sections = transformData(tabData);

  return (
    <div className="container py-5">
      <div className="row mb-4">
        <div className="col-12">
          <h4 className="mb-1" style={{ color: "#333", fontWeight: "600" }}>
            Education & Training
          </h4>
          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            A comprehensive overview of academic achievements, medical training,
            and professional credentials that reflect expertise in orthopaedics
            and sports medicine.
          </p>
        </div>
      </div>

      <div className="bg-white rounded p-4">
        <div className="row" style={{ alignItems: "stretch" }}>
          {sections.map((section, index) => (
            <SectionCard
              key={index}
              title={section.title}
              icon={getIcon(section.title)}
              headerClass={getHeaderClass(section.title)}
              items={section.items}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EducationProfileUpdated;
